import React from "react";

const useModal = () => {
  let [modal, setModal] = React.useState(false);
  let [modalContent, setModalContent] = React.useState(false);

  let handleModal = (
    content = false,
    isCloseAction,
  ) => {
    if (!isCloseAction) {
      setModal(!modal);
    } else {
      setModal(false);
    }

    if (content) {
      setModalContent(content);
    }
  };

  return { modal, handleModal, modalContent };
};

export default useModal;
